import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { SignUpActions } from '../actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { SignUpService } from '../../services/sign-up.service';

@Injectable()
export class SignUpEffects {
  // signUp$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(SignUpActions.SignUp),
  //     switchMap(({ payload }) =>
  //       this.signUpService.signUp(payload).pipe(
  //         map(payload => {
  //           this.router.navigate(['/auth/login']);
  //           return SignUpActions.SignUpSuccess();
  //         }),
  //         catchError((error: HttpErrorResponse) => {
  //           return of(SignUpActions.SignUpError(error));
  //         }),
  //       ),
  //     ),
  //   ),
  // );

  constructor(
    private signUpService: SignUpService,
    private actions$: Actions,
    private router: Router,
  ) {}
}
